import React, { useState } from "react";
import { FaPlusCircle } from "react-icons/fa";

const Logisticssubscriptiondata = () => {
    const [showModal, setShowModal] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [planType, setPlanType] = useState("LEADS");
    const [dayPrice, setDayPrice] = useState("");
    const [leads, setLeads] = useState("");
    const [commissionRate, setCommissionRate] = useState("");
    const [discountPercentage, setDiscountPercentage] = useState("");
    const [editIndex, setEditIndex] = useState(null);

    const [configList, setConfigList] = useState([]);

    const openModal = (plan = null, index = null) => {
        if (plan) {
            setEditMode(true);
            setEditIndex(index);
            setPlanType(plan.planType);
            setDayPrice(plan.dayPrice || "");
            setLeads(plan.leads || "");
            setCommissionRate(plan.commissionRate || "");
            setDiscountPercentage(plan.discountPercentage || "");
        } else {
            setEditMode(false);
            setEditIndex(null);
            setPlanType("LEADS");
            setDayPrice("");
            setLeads("");
            setCommissionRate("");
            setDiscountPercentage("");
        }
        setShowModal(true);
    };

    const closeModal = () => setShowModal(false);

    const handleSubmit = (e) => {
        e.preventDefault();

        const baseDayPrice = parseInt(dayPrice, 10) || 0;
        const discount = parseInt(discountPercentage, 10) || 0;

        const calculatedPrices = {
            day: baseDayPrice,
            week: Math.round(baseDayPrice * 7 * (1 - discount / 100)),
            month: Math.round(baseDayPrice * 30 * (1 - discount / 100)),
            year: Math.round(baseDayPrice * 365 * (1 - discount / 100)),
        };

        const payload = {
            planType,
            dayPrice: baseDayPrice,
            discountPercentage: discount,
            prices: calculatedPrices,
            leads,
            commissionRate,
            updatedBy: "SUPER-ADMIN",
            updatedAt: new Date().toISOString(),
        };

        if (editMode && editIndex !== null) {
            const updatedList = [...configList];
            updatedList[editIndex] = payload;
            setConfigList(updatedList);
        } else {
            setConfigList([...configList, payload]);
        }

        closeModal();
    };

    return (
        <div className="container-fluid py-4" style={{ marginTop: "120px" }}>
            <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-10">
                    <div style={{ textAlign: "center" }}>
                        <div style={{ marginTop: "5px", marginLeft: "-57px" }} className="col-12 text-center mb-4">
                            <button className="btn btn-lg btn-success" onClick={() => openModal()}>
                                <FaPlusCircle className="me-2" /> Create New Plan
                            </button>
                        </div>
                    </div>

                    {/* Cards */}
                    <div className="container">
                        <div className="row">
                            {configList.length > 0 ? (
                                configList.map((config, index) => (
                                    <div
                                        className="col-md-4 mb-3"
                                        key={index}
                                        style={{ width: "330px" }}
                                    >
                                        <div className="card shadow border-0 h-100">
                                            <div
                                                className="card-header text-white d-flex justify-content-between"
                                                style={{ background: "#a055b0" }}
                                            >
                                                <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                                                    {config.planType === "LEADS"
                                                        ? "Leads Plan"
                                                        : "Commission Plan"}
                                                </span>
                                                <button
                                                    className="btn btn-sm btn-light"
                                                    onClick={() => openModal(config, index)}
                                                >
                                                    ✏️
                                                </button>
                                            </div>

                                            <div className="card-body">
                                                {config.planType === "LEADS" && (
                                                    <>
                                                        {/* Discount only for leads */}
                                                        <p className="mb-2 fw-bold text-primary">
                                                            Discount: {config.discountPercentage}%
                                                        </p>

                                                        <h6 className="fw-bold mb-2">
                                                            Price Plans (with Discount)
                                                        </h6>
                                                        <ul className="list-group mb-3">
                                                            <li className="list-group-item d-flex justify-content-between">
                                                                <span>Day</span>
                                                                <span>₹{config.prices.day}</span>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between">
                                                                <span>Week</span>
                                                                <span>₹{config.prices.week}</span>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between">
                                                                <span>Month</span>
                                                                <span>₹{config.prices.month}</span>
                                                            </li>
                                                            <li className="list-group-item d-flex justify-content-between">
                                                                <span>Year</span>
                                                                <span>₹{config.prices.year}</span>
                                                            </li>
                                                        </ul>
                                                        <div className="d-flex justify-content-between">
                                                            <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                                                                Leads
                                                            </span>
                                                            <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                                                                {config.leads}
                                                            </span>
                                                        </div>
                                                    </>
                                                )}

                                                {config.planType === "COMMISSIONS" && (
                                                    <>
                                                        <h5 className="card-title text-center fw-bold mb-3">
                                                            {config.commissionRate}% Commission
                                                        </h5>
                                                        <p className="text-muted text-center">
                                                            This plan is commission-based only.
                                                            Charges will apply as per the agreed commission rate.
                                                        </p>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p>No plan data found. Please add one.</p>
                            )}
                        </div>
                    </div>

                    {/* Modal */}
                    {showModal && (
                        <div
                            className="modal fade show d-block"
                            tabIndex="1"
                            style={{
                                backgroundColor: "#00000088",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "100vh",
                            }}
                        >
                            <div className="modal-dialog">
                                <div className="modal-content" style={{ maxWidth: "35vw", top: "54px" }}>
                                    <form onSubmit={handleSubmit}>
                                        <div className="modal-header">
                                            <h5 className="modal-title">
                                                {editMode ? "Edit" : "Add"} Plan
                                            </h5>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                onClick={closeModal}
                                            ></button>
                                        </div>
                                        <div className="modal-body">
                                            {/* Plan Type */}
                                            <div className="mb-2">
                                                <label className="form-label">Plan Type</label>
                                                <select
                                                    className="form-select"
                                                    value={planType}
                                                    onChange={(e) => setPlanType(e.target.value)}
                                                    required
                                                >
                                                    <option value="LEADS">Leads</option>
                                                    <option value="COMMISSIONS">Commissions</option>
                                                </select>
                                            </div>

                                            {/* Base Day Price - only required for Leads */}
                                            {planType === "LEADS" && (
                                                <div className="mb-2">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={dayPrice}
                                                        onChange={(e) => setDayPrice(e.target.value)}
                                                        placeholder="Enter 1 Day Price"
                                                        required
                                                    />
                                                </div>
                                            )}

                                            {/* Discount % - only for Leads */}
                                            {planType === "LEADS" && (
                                                <div className="mb-2">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={discountPercentage}
                                                        onChange={(e) => setDiscountPercentage(e.target.value)}
                                                        placeholder="Discount Percentage (%)"
                                                        min="0"
                                                        max="100"
                                                        required
                                                    />
                                                </div>
                                            )}

                                            {/* Leads */}
                                            {planType === "LEADS" && (
                                                <div className="mb-2">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={leads}
                                                        onChange={(e) => setLeads(e.target.value)}
                                                        placeholder="Number of Leads"
                                                        required
                                                    />
                                                </div>
                                            )}

                                            {/* Commission */}
                                            {planType === "COMMISSIONS" && (
                                                <div className="mb-2">
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={commissionRate}
                                                        onChange={(e) => setCommissionRate(e.target.value)}
                                                        placeholder="Commission Rate (%)"
                                                        required
                                                    />
                                                </div>
                                            )}
                                        </div>
                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={closeModal}
                                            >
                                                Cancel
                                            </button>
                                            <button type="submit" className="btn btn-primary">
                                                {editMode ? "Update" : "Add"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Logisticssubscriptiondata;
